import * as React from 'react';
import ListItem from '@material-ui/core/ListItem';

const CustomListItem = (props) => {
    return <ListItem {...props} />;
};

export { CustomListItem as ListItem };
